import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  FormControl,
  FormHelperText,
  FormLabel,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from "react";
import * as yup from 'yup';
import 'react-datepicker/dist/react-datepicker.css';
import { getFormattedDate } from "@/queue/elements/value-formatters/date-formatter.mjs";
import ControlledInput from "@/common/ControllerInput";
import { useDispatch } from "react-redux";
import { setIsCreateDealerActionCompleted, setIsCreateDealerActionInprogress, callToCreateDealerAction } from '@/explore/ducks/slice';
import { getIsCreateDealerActionCompleted, getIsCreateDealerActionInprogress } from '@/explore/ducks/selectors';
import { DealerProfileType } from '@masterffl/dealer-profile-component';
import { checkIsStateCA } from '@/utils/utils';
type Props = {
  open: boolean;
  close: () => void;
  data?: any;
  dealerDetails?: DealerProfileType
};

interface Errors {
  printedName: string | null,
  title: string | null,
  licenseDate: Date | null
}
const LicenseAttributesEditModal = ({ open, close, data, dealerDetails }: Props) => {
  const dispatch = useDispatch()
  const isCreateDealerActionCompleted = getIsCreateDealerActionCompleted();
  const isCreateDealerActionInprogress = getIsCreateDealerActionInprogress();
  const [printedName, setPrintedName] = useState<{ id: string; value: string; error?: string; defaultValue: string }>({
    id: 'printedName',
    value: '',
    error: '',
    defaultValue: ''
  });
  const [title, setTitle] = useState<{ id: string; value: string; error?: string; defaultValue: string }>({
    id: 'title',
    value: '',
    error: '',
    defaultValue: ''
  });
  const [licenseDate, setLicenseDate] = useState<{ id: string; value: string; error?: string; defaultValue: string }>({
    id: 'licenseDate',
    value: '',
    error: '',
    defaultValue: ''
  });
  const [cfd, setCfd] = useState<{ id: string; value: string; error?: string; defaultValue: string }>({
    id: 'cfd',
    value: '',
    error: '',
    defaultValue: ''
  });
  const [isSaveDisabled, setIsSaveDisabled] = useState<boolean>(true);
  const datePickerRef = useRef<any>(null);

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  useEffect(() => {
    let isFormChanged = false;
    if (printedName.value !== (data?.printedName ? data?.printedName : '') || 
    // title.value !== (data?.printedPosition ? data?.printedPosition : '') || 
    // licenseDate.value !== (data?.licenseDate ? getFormattedDate(data?.licenseDate) : '') || 
    cfd.value !== (data?.cfd ? data?.cfd : ''))
      isFormChanged = true;
    setIsSaveDisabled(!isFormChanged);
  }, [data, printedName.value, title.value, licenseDate.value, cfd.value]);

  const LicenseFormSchema = yup.object().shape({
    printedName: yup.string().max(90, "Name on License must be at most 90 characters."),
    title: yup.string().max(90, "Title must be at most 90 characters."),
    cfd: yup.string().max(5, "CFD must be at most 5 digits."),
  })

  async function validation(
    value: string,
    fieldName: string
  ) {
    try {
      await LicenseFormSchema.validateAt(fieldName, { [fieldName]: value });
      return '';
    } catch (error: any) {
      console.error("SHEMA ERR : ", error);
      return error.errors && error.errors.length > 0 ? error.errors[0] : '';
    }
  }

  const onChangeName = async (value: string, fieldName: string) => {
    const error = await validation(value, fieldName);
    const nameData = {
      ...printedName,
      value: value,
      error: ''
    }
    if (error) {
      nameData['error'] = error;
    }
    setPrintedName(nameData);
  }
  // const onChangeTitle = async (value: string, fieldName: string) => {
  //   const error = await validation(value, fieldName);
  //   const titleData = {
  //     ...title,
  //     value: value,
  //     error: ''
  //   }
  //   if (error) {
  //     titleData['error'] = error;
  //   }
  //   setTitle(titleData);
  // }
  // const onChangeDate = async (date: Date) => {
  //   const dateData = {
  //     ...licenseDate,
  //     value: getFormattedDate(date) || '',
  //     error: ''
  //   }
  //   setLicenseDate(dateData);
  // }

  const onlyDigitsRegex = /^[0-9]*$/;
  const onChangeCfd = async (value: string, fieldName: string) => {

    if (!onlyDigitsRegex.test(value)) {
    return;
  }

    const error = await validation(value, fieldName);

    const cfdData = {
      ...cfd,
      value: value == '0' || value == '' ? '' : value,
      error: ''
    }
    if (error) {
      cfdData['error'] = error;
    }
    setCfd(cfdData);
  }
  useEffect(() => {
    if (data) {
      if (data?.printedName) {
        setPrintedName({
          ...printedName,
          value: data?.printedName ? data?.printedName : '',
          defaultValue: data?.printedName ? data?.printedName : ''
        })
      }
      // if (data?.printedPosition) {
      //   setTitle({
      //     ...title,
      //     value: data?.printedPosition ? data?.printedPosition : '',
      //     defaultValue: data?.printedPosition ? data?.printedPosition : ''
      //   })
      // }
      // if (data?.licenseDate) {
      //   setLicenseDate({
      //     ...licenseDate,
      //     value: data?.licenseDate ? getFormattedDate(data?.licenseDate) as string : '',
      //     defaultValue: data?.licenseDate ? getFormattedDate(data?.licenseDate) as string : ''
      //   })
      // }
    }
  }, [data])
  useEffect(() => {
    if(dealerDetails?.businessDetails){
      setCfd({
        ...cfd,
        value: dealerDetails?.businessDetails?.cfd && dealerDetails?.businessDetails?.cfd !==  null ? dealerDetails?.businessDetails?.cfd.toString() : '',
        defaultValue: dealerDetails?.businessDetails?.cfd && dealerDetails?.businessDetails?.cfd !==  null ? dealerDetails?.businessDetails?.cfd.toString() : ''
      })
    }
  },[dealerDetails])
  useEffect(() => {
    if (!isCreateDealerActionInprogress && isCreateDealerActionCompleted) {
      close();
      setPrintedName({ ...printedName, error: '' })
      setTitle({ ...title, error: '' })
      setLicenseDate({ ...licenseDate, error: '' })
      setCfd({ ...cfd, error: '' })
      dispatch(setIsCreateDealerActionCompleted(false));
    }
  }, [isCreateDealerActionInprogress, isCreateDealerActionCompleted]);

  const onCancelBtnClick = ((isNew: boolean = false) => {
    if (isNew) {
      setPrintedName({ ...printedName, error: '' })
      setTitle({ ...title, error: '' })
      setLicenseDate({ ...licenseDate, error: '' })
      setCfd({ ...cfd, error: '' })
    }
    else {
      setPrintedName({ ...printedName, value: printedName.defaultValue, error: '' })
      setTitle({ ...title, value: title.defaultValue, error: '' })
      setLicenseDate({ ...licenseDate, value: licenseDate.defaultValue, error: '' })
      setCfd({ ...cfd, value: cfd.defaultValue, error: '' })
    }
    close()
  })
  const onSaveHandler = async () => {
    try {
      await dispatch(setIsCreateDealerActionInprogress(true));
      let payload: any;
      if (data?.certificateRowId && checkIsStateCA(data?.premiseAddress?.state)) {
        payload = {
          name: 'license_details',
          type: 'update',
          dealer_id: dealerDetails?._id as string,
          license_key: data?.licenseKey,
          id: data?.certificateRowId || null,
          printed_name: printedName.value,
          // position_title: title.value,
          // printed_date: licenseDate.value,
          source: 'ffl360',
          old_name: data?.printedName,
          cfd: cfd.value === '' ? '' : cfd.value,
        }
      }
      else if (data?.certificateRowId) {
        payload = {
          name: 'license_details',
          type: 'update',
          dealer_id: dealerDetails?._id as string,
          license_key: data?.licenseKey,
          id: data?.certificateRowId || null,
          printed_name: printedName.value,
          // position_title: title.value,
          // printed_date: licenseDate.value,
          source: 'ffl360',
          old_name: data?.printedName,
        }
      }
      else if (checkIsStateCA(data?.premiseAddress?.state)) {
        payload = {
          name: 'license_details',
          type: 'update',
          dealer_id: dealerDetails?._id as string,
          license_key: data?.licenseKey,
          source: 'ffl360',
          cfd: cfd.value === '' ? `${Number(cfd.value)}` : cfd.value,
        }
      }

      dispatch(
        callToCreateDealerAction({
          licenseAttributeUpdatePayload: [payload]
        })
      );
    }
    catch (err) {
      console.log(err)
    }
  }

  const isCFDEditShow = () => {
    return dealerDetails?.licenses?.[0]?.licenseKey === data?.licenseKey;
  }

  return <Modal closeOnOverlayClick={false} isOpen={open} onClose={close} isCentered>
    <ModalOverlay />
    <ModalContent
      maxWidth={'534px'}
      maxHeight={'90vh'}
      scrollBehavior={'auto'}
    >
      <ModalHeader className="store-contact-details-edit-header">
        Edit License Details
        <button className="transfer-create-modal__close-btn" onClick={() => onCancelBtnClick()}>
          <img src="/images/ui/close.svg" />
        </button>
      </ModalHeader>
      <ModalBody className={'store-contact-details-edit-body'}>
        {data?.certificateRowId && <Box>
          <FormControl className="transfer-form__item" padding={'1rem'}>
            <FormLabel className="transfer-form__label">License Responsible Name:</FormLabel>
            <Box display="flex" flexDirection="column">
              <ControlledInput
                type="text"
                placeholder="Enter License Responsible Name"
                value={printedName?.value}
                onChange={(event) => onChangeName(event.target.value.trimStart(), 'printedName')}
              />
              {printedName.error && <FormHelperText color={'red'} paddingLeft={'0.5rem'}>
                *{printedName.error}
              </FormHelperText>
              }
            </Box>
          </FormControl>
        </Box>}
        {(checkIsStateCA(data?.premiseAddress?.state) && isCFDEditShow()) && 
        <FormControl className="transfer-form__item" padding={'1rem'}>
          <FormLabel className="transfer-form__label">CFD:</FormLabel>
          <Box display="flex" flexDirection="column">
            <ControlledInput
              maxWidth={'100%'}
              type="number"
              value={cfd?.value}
              onChange={(event) => onChangeCfd(event.target.value.trimStart(), 'cfd')}
              placeholder="Enter CFD"
              id='cfdNumberInputField'
            />
            {cfd.error && <FormHelperText className="failed" color={'red'} paddingLeft={'0.5rem'}>
              *{cfd.error}
            </FormHelperText>}
          </Box>
        </FormControl>
        }
      </ModalBody>
      <ModalFooter className={`store-contact-details-edit-footer`}>
        <Button
          colorScheme="blue"
          onClick={() => onCancelBtnClick()}
          background="#ffffff"
          color="#0C1E46"
          border="1px solid #0C1E46"
          padding="8px 11px"
          fontSize={'16px'}
          marginRight="20px"
          height={'35px'}
          width={'100px'}
          isDisabled={isCreateDealerActionInprogress}
        >
          Cancel
        </Button>
        <Button
          colorScheme="blue"
          background="#0C1E46"
          height={'35px'}
          width={'100px'}
          fontSize={'16px'}
          padding="8px 20px"
          onClick={onSaveHandler}
          isLoading={isCreateDealerActionInprogress}
          isDisabled={isCreateDealerActionInprogress || printedName.error !== '' || 
            // title.error !== '' || 
            cfd.error != '' || isSaveDisabled || (cfd.value != '' && cfd?.value?.length < 5)}
        >
          Save
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
}

export default LicenseAttributesEditModal;
